// table-expand.vue
<style scoped>
.expand-row {
  margin-bottom: 16px;
  margin-left: 40px;
}
.expand-key {
  margin-left: 16px;
  margin-right: 16px;
  font-weight: bold;
}
.expand-value {
  margin-right: 16px;
}
</style>
<template>
  <Collapse simple>
    <Panel name="3">
      地址信息
      <div slot="content">
        <Row class="expand-row">
          <Col span="20">
            <span class="expand-key">地址信息：</span>
            <span class="expand-value">{{ row.completeAddress }}</span>
          </Col>
        </Row>
      </div>
    </Panel>
    <Panel name="4">
      用户信息
      <div slot="content">
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">用户姓名：</span>
            <span class="expand-value">{{ row.customerName }}</span>
          </Col>
          <Col span="12">
            <span class="expand-key">用气类型：</span>
            <span class="expand-value">{{ row.customerGasType }}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">身份证号：</span>
            <span class="expand-value">{{ row.customerIdcard }}</span>
          </Col>
          <Col span="12">
            <span class="expand-key">用户状态：</span>
            <span class="expand-value">{{ row.customerStatus }}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">联系电话：</span>
            <span class="expand-value">{{ row.customerPhone }}</span>
          </Col>
          <Col span="12">
            <span class="expand-key">设备底数：</span>
            <span class="expand-value">{{ row.meterBaseNumber }}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">用户备注：</span>
            <span class="expand-value">{{ row.customerRemark }}</span>
          </Col>
        </Row>
      </div>
    </Panel>
    <Panel name="1">
      表具详细信息
      <div slot="content">
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">通讯方式：</span>
            <span class="expand-value">{{ row.meterCommunicationMode }}</span>
          </Col>
          <Col span="12">
            <span class="expand-key">设备串号：</span>
            <span
              class="expand-value"
            >{{ row.meterSerialNumber == "" ? '无' : row.meterSerialNumber}}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">设备状态:</span>
            <span class="expand-value">{{ row.meterUsageState == 0 ? "待开户" : (row.meterUsageState == 10 ? "待安检" :(row.meterUsageState == 20 ? "正常使用":"异常")) }}</span>
          </Col>

          <Col span="12">
            <span class="expand-key">注册编号：</span>
            <span class="expand-value">{{ row.meterRegisterKey }}</span>
          </Col>
        </Row>
      </div>
    </Panel>
    <Panel name="2" v-if="this.type == '维修'">
      设备类型信息
      <div slot="content">
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">设备类型：</span>
            <span class="expand-value">{{ row.meterTypeName }}</span>
          </Col>
          <Col span="12">
            <span class="expand-key">计费方式：</span>
            <span class="expand-value">{{ row.meterTypePayType }}</span>
          </Col>
        </Row>
        <Row class="expand-row">
          <Col span="12">
            <span class="expand-key">类型描述:</span>
            <span class="expand-value">{{ row.meterTypeRemark }}</span>
          </Col>
        </Row>
      </div>
    </Panel>
  </Collapse>
</template>
<script>
export default {
  props: {
    row: Object,
    type: ""
  }
};
</script>